<div class="card">
  <div class="card-body">
    @if (isForSystemTest) {
      <div style="color: red; font-weight: bold; font-size: 16px; margin-bottom: 10px;">
        <a><b>Dieser Mandant ist für Systemtests angelegt!</b></a>
        <br><br>
      </div>
    }
    <form [formGroup]="editTenantForm" novalidate>
      <div class="row">
        <div class="col-md-12">
          <mat-form-field style="width: 0; height: 0;">
            <input matInput hidden  formControlName="id">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <mat-form-field class="example-full-width">
            <mat-label>Max. Anzahl Mitglieder</mat-label>
            <input matInput formControlName="maxUserCount">
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field class="example-full-width">
            <mat-label>Max. Anzahl Projekte</mat-label>
            <input matInput formControlName="maxProjectCount">
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field class="example-full-width">
            <mat-label>Einladung für Mitglieder gültig (Tage)</mat-label>
            <input matInput formControlName="invitationValidForDays">
          </mat-form-field>
        </div>
        <div class="col-md-12">
          <mat-form-field class="example-full-width">
            <mat-label>KI-Token</mat-label>
            <input matInput formControlName="kiToken">
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <!-- <mat-form-field class="example-full-width">
          <input matInput placeholder="gebuchte Zusatzmodule" formControlName="additionalModules">
        </mat-form-field> -->
        <div class="module-list-header">Gebuchte Zusatzmodule (gebucht/verwendet/verfügbar):</div>
        <div class="module-list">
          @if (availableModules.length == 0) {
            <div class="module-row module-row-empty">- keine Zusatzmodule gebucht -</div>
          }
          @if (availableModules.length > 0) {
            @for (module of availableModules; track module) {
              <div class="module-row" >
                <span class="module-name">{{module.moduleName}}</span>
                <span class="module-count">{{module.count}}/{{module.usedCount}}/{{module.count - module.usedCount}}</span>
              </div>
            }
          }
        </div>
        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px"
          matTooltip="Weitere Module hinzufügen oder entfernen"
          (click)="addModule()" >Zusatzmodule bearbeiten
        </button>
      </div>
    </div>

    <br><br>

    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
    (click)="cancel()" >Abbruch</button>
    <!-- <span style="flex: 1 1 auto"></span> -->
    <button mat-raised-button type="submit" class="btn btn-squirrel pull-right" matTooltip="Vertragsadaten speichern"
    (click)="editTenant()">Vertragsdaten speichern</button>
    <div class="clearfix"></div>
  </form>
</div>
</div>